import React, { useState, useEffect } from "react";
import { Chart, ChartLegend, ChartSeries, ChartSeriesItem, ChartTitle } from "@progress/kendo-react-charts";
import { sbaAxios } from "../utils/sbaAxios";
import { getClassiSummary } from "../../config/apiConfig";
import { WidgetCollectionContext } from "./home";
import { useContext } from "react";

import CloseSVG from "../../Images/close_svg.svg";

const TotalInvestment = () => {
const [donut,setDonut]=useState([]);
const [selectedMode,setSelectedMode]=useState(1000);

const { removeWidget , toCustomize } = useContext(WidgetCollectionContext);
useEffect(()=>{
  fetchClassificationSummary(1000);
},[]);
  const totalMarketValue = donut.reduce((sum, item) => sum + item.marketValue, 0); // Calculate total market value
  const donutRor = donut.map((item) => ({
    category: item.classificationName,
    value: item.marketValue,
  }));
  const ClassificationButtons = [
    {
      buttonName: 'Strategy',
      buttonValue: 14
    },
    {
      buttonName: 'Sector',
      buttonValue: 63
    },
    {
      buttonName: 'Report Strategy',
      buttonValue: 1000
    }
  ];
  const classifyButtonClick = ( buttonId) => {
    setSelectedMode(buttonId)
    fetchClassificationSummary(buttonId);
  };
  const fetchClassificationSummary = async (parentClassId) => {
    try {
      const list = await sbaAxios({
        url: getClassiSummary,
        params: {
          parentClassId: parentClassId
        }
      });
      setDonut(list);
    }
    catch (e) {
      setDonut([]);
    }
  };
  return <>
  <div className="k-tilelayout-item k-card k-cursor-grab h-100">
    <div className="k-tilelayout-item-header k-card-header">
      <div className="header-container">
        <b>{ClassificationButtons.find(item=>item.buttonValue==selectedMode).buttonName+ " Allocation"}</b>
        <div className="button-container ms-auto">
          {ClassificationButtons.map((button, index) => (
            <button
              key={index}
              className={selectedMode === button.buttonValue ? "selected-non-gappable-button p-2" : "non gappable-button p-2"}
              onClick={() => {
                classifyButtonClick(button.buttonValue);
              }}
            >
              {button.buttonName}
            </button>

          ))}
        </div>
        {toCustomize && <a className="" href="#" onClick={() => {
           removeWidget(4)
        }}>
          <img src={CloseSVG}
            alt="close" />
    </a>}


      </div>
    </div>
    <div className="k-tilelayout-item-body k-card-body">
    <Chart style={{
      height: "100%"
    }}>
      {/* <ChartTitle
        text={`Total Investment: ${totalMarketValue.toLocaleString()}`}
        align="center"
        position="top"
      /> */}
      <ChartSeries>
        <ChartSeriesItem type="pie" data={donutRor} field="value" categoryField="category"
          labels={{
            visible: true,
            content: (e) => `${((e.value / totalMarketValue) * 100).toFixed(2)}%`, // Display percentage
          }} />
      </ChartSeries>
      <ChartLegend position={"bottom"} visible={true} />
    </Chart>
    </div>
    </div>
  </>


};
export default TotalInvestment;